import { useEffect } from 'react';

/**
 * Removes the static `data-default="true"` og/twitter fallback tags from
 * index.html once a page that renders its own complete og/twitter set is
 * mounted.
 *
 * react-helmet-async injects route-specific social tags but only manages tags it
 * created — it never removes the static defaults baked into index.html. Left in
 * place, those defaults duplicate og:title/og:description in the live DOM and the
 * generic default wins for JS clients (and Google's renderer).
 *
 * No-JS scrapers still read the raw-HTML fallbacks; prerendered pages have the
 * defaults stripped at build time (scripts/strip-prerender-defaults.cjs). Only
 * call this from a component that provides a full replacement set, or the page
 * will be left with no social tags at all.
 */
export function useStripDefaultMeta(): void {
  useEffect(() => {
    document.head.querySelectorAll('meta[data-default="true"]').forEach(el => el.remove());
  }, []);
}
